import img1 from "./WhatsApp Image 2025-12-14 at 9.31.22 PM.jpeg";
import img2 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (1).jpeg";
import img3 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (2).jpeg";
import img4 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (3).jpeg";
import img5 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (4).jpeg";
import img6 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (5).jpeg";
import img7 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (6).jpeg";
import img8 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (7).jpeg";
import img9 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (8).jpeg";
import img10 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (9).jpeg";
import img11 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (10).jpeg";
import img12 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (11).jpeg";
import img13 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (12).jpeg";
import img14 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (13).jpeg";
import img15 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (14).jpeg";
import img16 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM (15).jpeg";
import img17 from "./WhatsApp Image 2025-12-14 at 9.31.23 PM.jpeg";
import img18 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (1).jpeg";
import img19 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (2).jpeg";
import img20 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (3).jpeg";
import img21 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (4).jpeg";
import img22 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (5).jpeg";
import img23 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (6).jpeg";
import img24 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (7).jpeg";
import img25 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (8).jpeg";
import img26 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM (9).jpeg";
import img27 from "./WhatsApp Image 2025-12-14 at 9.31.24 PM.jpeg";
import img28 from "./WhatsApp Image 2025-12-14 at 9.31.25 PM (1).jpeg";
import img29 from "./WhatsApp Image 2025-12-14 at 9.31.25 PM (2).jpeg";
import img30 from "./WhatsApp Image 2025-12-14 at 9.31.25 PM.jpeg";
import img31 from "./WhatsApp Image 2025-12-14 at 9.31.27 PM (1).jpeg";
import img32 from "./WhatsApp Image 2025-12-14 at 9.31.27 PM (2).jpeg";
import img33 from "./WhatsApp Image 2025-12-14 at 9.31.27 PM (3).jpeg";
import img34 from "./WhatsApp Image 2025-12-14 at 9.31.27 PM (4).jpeg";
import img35 from "./WhatsApp Image 2025-12-14 at 9.31.27 PM.jpeg";
import img36 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (1).jpeg";
import img37 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (2).jpeg";
import img38 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (3).jpeg";
import img39 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (4).jpeg";
import img40 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (5).jpeg";
import img41 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (6).jpeg";
import img42 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (7).jpeg";
import img43 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (8).jpeg";
import img44 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (9).jpeg";
import img45 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (10).jpeg";
import img46 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (11).jpeg";
import img47 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (12).jpeg";
import img48 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (13).jpeg";
import img49 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (14).jpeg";
import img50 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (15).jpeg";
import img51 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (16).jpeg";
import img52 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (17).jpeg";
import img53 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (18).jpeg";
import img54 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM (19).jpeg";
import img55 from "./WhatsApp Image 2025-12-14 at 9.31.28 PM.jpeg";
import img56 from "./WhatsApp Image 2025-12-14 at 9.31.29 PM (1).jpeg";
import img57 from "./WhatsApp Image 2025-12-14 at 9.31.29 PM (2).jpeg";
import img58 from "./WhatsApp Image 2025-12-14 at 9.31.29 PM (3).jpeg";
import img59 from "./WhatsApp Image 2025-12-14 at 9.31.29 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
  img46,
  img47,
  img48,
  img49,
  img50,
  img51,
  img52,
  img53,
  img54,
  img55,
  img56,
  img57,
  img58,
  img59,
];
